import { useState, useEffect } from "react";
import axios from "axios";
import "../src/assets/components/global.css";
import { useParams, useNavigate } from "react-router-dom";
import AutoLogout from "./autologout";

function Myinfo() {
  const [personaldata, setPersonalInfo] = useState({});
  const [usersdata, setUserinfo] = useState({});
  const { brgyId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Make an API call to fetch user information based on brgyId
        const response = await axios.get(
          `https://brgytracerappserver.onrender.com/myinfo/${brgyId}`
        );
        const { personalinfo, usersinfo } = response.data; // Destructure personalinfo and usersinfo from response data

        // Access personal information
        setPersonalInfo(personalinfo[0]); // Set personal information state
        // Access user information
        setUserinfo(usersinfo[0]); // Set user information state

        console.log("personalinfo:", personalinfo);
        console.log("usersinfo:", usersinfo);
      } catch (error) {
        console.error("Error fetching user information:", error);
      }
    };

    fetchData(); // Call the fetchData function when the component mounts
  }, [brgyId]); // Re-run the effect when brgyId changes

  const setRequest = () => {
    navigate(`/requestUpdatepage/${brgyId}`);
  };
  const handleclose = () => {
    navigate(`/memberpage/${brgyId}`);
  };

  return (
    <div className="Myinfo-parent parent-height">
      <AutoLogout />
      <div className="Myinfo-holder">
        <div className="account-bar">
          <h3>Account information</h3>
          <div className="account-content">
            <div>
              <label>Username:</label>
              <p>{usersdata.username}</p>
            </div>
            <div>
              <label>Email:</label>
              <p>{usersdata.email}</p>
            </div>
            <div>
              <label>Password:</label>
              <p>{usersdata.password}</p>
            </div>
            <div>
              <label>Role:</label>
              <p>{usersdata.role}</p>
            </div>
          </div>
        </div>
        <div className="info-bar">
          <h3>User Information</h3>
          <div className="info-content">
            <div>
              <label>First Name:</label>
              <p>{personaldata.firstname}</p>
            </div>
            <div>
              <label>Middle Name:</label>
              <p>{personaldata.middlename}</p>
            </div>
            <div>
              <label>Last Name:</label>
              <p>{personaldata.lastname}</p>
            </div>
            <div>
              <label>Age:</label>
              <p>{personaldata.age}</p>
            </div>
            <div>
              <label>Birth Date:</label>
              <p>{personaldata.birthdate}</p>
            </div>
            <div>
              <label>Gender:</label>
              <p>{personaldata.gender}</p>
            </div>
            <div>
              <label>Civil Status:</label>
              <p>{personaldata.civilstatus}</p>
            </div>
            <div>
              <label>Religion:</label>
              <p>{personaldata.religion}</p>
            </div>
            <div>
              <label>Nationality:</label>
              <p>{personaldata.nationality}</p>
            </div>
            <div>
              <label>Phone Number:</label>
              <p>{personaldata.cellnumber}</p>
            </div>
            <div>
              <label>Recentaddress:</label>
              <p>{personaldata.recentaddress}</p>
            </div>
            <div>
              <label>Presentaddress:</label>
              <p>{personaldata.presentaddress}</p>
            </div>
          </div>
        </div>
        <div className="button-container">
          <button onClick={setRequest}>Request Update</button>
          <button className="backbutton" type="button" onClick={handleclose}>
            back
          </button>
        </div>
      </div>
    </div>
  );
}

export default Myinfo;
